import axiosIns from '@/libs/axiosIns'

const createInitialState = () => ({
  permissions: [],
  role: '',
  taxonomies: {
    accommodationFollowUpStatus: [],
    callLegitimate: [],
    conversationStatus: [],
    demandReason: [],
    demandType: [],
    deviceType: [],
    gender: [],
    howThePersonGotToKnowUs: [],
    messageDirection: [],
    messageStatus: [],
    messageType: [],
    notificationStatus: [],
    senderType: [],
    situationOfAccommodation: [],
    ageRange: [],
  },
})

export default {
  namespaced: true,
  state: createInitialState(),
  getters: {
    getPermissions: state => state.permissions,
    getTaxonomies: state => state.taxonomies,
  },
  mutations: {
    setInitialData(state, data) {
      state.taxonomies = data.taxonomies
      state.permissions = data.permissions
      state.role = data.role
    },
    // Clears permissions/taxonomies cached from a previous session so that components which
    // only fetch when "not already loaded" (e.g. `if (!permissions.length) fetchInitialData()`)
    // correctly refetch for the newly authenticated user instead of keeping stale permissions.
    resetState(state) {
      Object.assign(state, createInitialState())
    },
  },
  actions: {
    fetchInitialData({ commit }) {
      return new Promise((resolve, reject) => {
        axiosIns.get('Configuration/InitialData')
          .then(response => {
            commit('setInitialData', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
